module.exports = __webpack_public_path__ + "img/s5-1.d55c3b25.jpg";